import { render, staticRenderFns } from "./ui-switch.vue?vue&type=template&id=5c4aff06&scoped=true"
import script from "./ui-switch.vue?vue&type=script&lang=js"
export * from "./ui-switch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4aff06",
  null
  
)

export default component.exports